/**
 * @generated SignedSource<<102ff6ad6461015139fb2d07e7516c10>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PreQuoteDutiesDescription_viewer$data = {
  readonly customsDuties: {
    readonly crossCustomsBorder: boolean | null;
    readonly incoterm: string | null;
  } | null;
  readonly " $fragmentType": "PreQuoteDutiesDescription_viewer";
};
export type PreQuoteDutiesDescription_viewer$key = {
  readonly " $data"?: PreQuoteDutiesDescription_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"PreQuoteDutiesDescription_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "buyerId"
    },
    {
      "kind": "RootArgument",
      "name": "destinationCountry"
    },
    {
      "kind": "RootArgument",
      "name": "itemId"
    },
    {
      "kind": "RootArgument",
      "name": "shipmentQuoteId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PreQuoteDutiesDescription_viewer",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "buyerId",
          "variableName": "buyerId"
        },
        {
          "kind": "Variable",
          "name": "destinationCountry",
          "variableName": "destinationCountry"
        },
        {
          "kind": "Variable",
          "name": "itemId",
          "variableName": "itemId"
        },
        {
          "kind": "Variable",
          "name": "shipmentQuoteId",
          "variableName": "shipmentQuoteId"
        }
      ],
      "concreteType": "CustomsDuties",
      "kind": "LinkedField",
      "name": "customsDuties",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "crossCustomsBorder",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "incoterm",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "9859ffbc706d4d8bd6144d92af7a9d1e";

export default node;
